<template>
  <card>
    <template slot="header">
      <h5 class="title">资料编辑</h5>
    </template>
    <div class="row">
      <div class="col-md-5 pr-md-1 text-left">
        <base-input
          label="Company (disabled)"
          placeholder="Company"
          v-model="model.company"
          disabled
        >
        </base-input>
      </div>
      <div class="col-md-3 px-md-1 text-left">
        <base-input
          label="Username"
          placeholder="Username"
          v-model="model.name"
        >
        </base-input>
      </div>
      <div class="col-md-4 pl-md-1 text-left">
        <base-input
          label="Email address"
          type="email"
		  v-model="model.email"
          placeholder="email address"
        >
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 pr-md-1 text-left">
        <base-input
          label="TEL"
          v-model="model.mobile"
          placeholder="tel"
        >
        </base-input>
      </div>
      <div class="col-md-6 pl-md-1 text-left">
<!--        <base-input
          label="Last Name"
          v-model="model.lastName"
          placeholder="Last Name"
        >
        </base-input> -->
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 pr-md-1 text-left">
        <base-input
          label="Country"
          v-model="model.country"
          placeholder="Country"
        >
        </base-input>
      </div>
	  
	  <div class="col-md-4 px-md-1 text-left">
	    <base-input label="City" v-model="model.city" placeholder="City">
	    </base-input>
	  </div>
	  
      <div class="col-md-4 pl-md-1 text-left">
        <!-- <base-input label="Postal Code" placeholder="ZIP Code"> </base-input> -->
      </div>
    </div>
	
	<div class="row">
	  <div class="col-md-12 text-left">
	    <base-input
	      label="Address"
	      v-model="model.address"
	      placeholder="Home Address"
	    >
	    </base-input>
	  </div>
	</div>
    <template slot="footer">		
      <button class="btn btn-primary"  @click="save()">Save</button>
    </template>
  </card>
</template>
<script>
import { Card, BaseInput } from "@/components/index";

import BaseButton from "@/components/BaseButton";

export default {
  components: {
    Card,
    BaseInput,
    BaseButton,
  },
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
	save(){
		let res =this.$axios.post(this.$serverUrl+"/user/update",this.model);
		if(res.data.status=="1"){
			this.msg="修改成功";
		}
	}   
  },
};
</script>
<style></style>
